<template>
  <div v-if="loading"></div>
  <div id="app" v-else>
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import {getOpenId} from './api/searchFoods'
export default {
  name: "App",
  data(){
    return {
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods:{
     //初始化函数
    init() {
      const status = this.weiXin();
      if (status) {
        const userOpenId = localStorage.getItem('openId')
        console.log(userOpenId)
        if(userOpenId){
          this.$store.commit('setOpenId',{
            openId:userOpenId,
          })
        } else {
          this.loading = true
          // const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc65c30eb188ceedb&redirect_uri=http%3A%2F%2Ftest0.hy-tsingtsing.cn%2F&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
          const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1cf1a7cddb81c939&redirect_uri=http%3A%2F%2Fm.hyjkjy.com%2Fshanshiapp%2F&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
          const code = this.getUrlParam('code')
          if(code == null || code == ""){
            window.location.href = url
          } else{
            getOpenId(code).then(res=>{
              if(res.data.code === 200){
                // this.openId = res.data.data.openid
                // this.profileImg = res.data.data.profileImg
                this.$store.commit('setOpenId',{
                  openId:res.data.data.openid,
                  profileImg: res.data.data.profileImg
                })
                localStorage.setItem('openId',res.data.data.openid)
                this.loading = false
              }
            })
          }
        }
      } else {
        // this.openId = 'oqX5i6nKjU-GVUgqEXdwnXML3gx8'
        // this.$store.commit('setOpenId',{openId:'oqX5i6nKjU-GVUgqEXdwnXML3gx8'})
      }
    },
    //解析code
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    // 判断是不是微信
    weiXin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style>
#app {
  background-color: #ffffff;
  overflow: auto;
}

@supports(bottom:env(safe-area-inset-bottom)){
  #app{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
